export default{
  candidateType: {
    name: "candidateType",
    component: "filterSelect",
    placeholder: "All",
    label: "Discipline",
    queryKey: "candidate_type_id__in",
    dependsOn: [],
    dependentFilter: [],
    secondLevelDependentDisable: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  studentType: {
    name: "studentType",
    component: "filterSelect",
    label: "Student Type",
    queryKey: "student_type_id__in",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  enrolementStatus: {
    name: "enrolementStatus",
    component: "filterSelect",
    label: "Enrolment Status",
    queryKey: "enrollment_status_id__in",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  }, 
  courseTitle: {
    name: "courseTitle",
    component: "filterSelect",
    label: "Course/Programme",
    queryKey: "course_title_id__in",
    dependsOn: [],
    dependentFilter: [],
    secondLevelDependentDisable: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  graduationYear: {
    name: "graduationYear",
    component: "filterSelect",
    label: "Graduation Year",
    queryKey: "graduation_year",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  gradePerformance: {
    name: "gradePerformance",
    component: "filterSelect",
    label: "Grade Performance",
    queryKey: "grade_performance",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  cpdTracking:{
    name: "cpdTracking",
    component: "filterSelect",
    label: "CPD Tracking",
    queryKey: "cpd_tracking",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  fullPartTime: {
    name: "fullPartTime",
    component: "filterSelect",
    label: "Study Mode",
    queryKey: "candidate_training_courses___full_part_time",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  sponsorship: {
    name: "sponsorship",
    component: "filterSelect",
    label: "Sponsorship",
    queryKey: "is_sponsored",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: true,
  },
  locationLanguage: {
    name: "locationLanguage",
    component: "filterSelect",
    label: "Language",
    queryKey: "language_ids__overlap",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: false,
  },
  available: {
    name: "available",
    component: "filterSelect",
    label: "Readiness",
    queryKey: "available__in",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: false,
  },
  nationalityInfo: {
    name: "nationalityInfo",
    component: "filterSelect",
    label: "Nationality",
    queryKey: "nationality_ids__overlap",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: false,
  },
  gender: {
    name: "gender",
    component: "filterSelect",
    label: "Gender",
    queryKey: "gender_id__in",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: false,
  },

};